var l={channelGrid:"rl2_PopularChannelsModal-module_channelGrid_vZE9g",channelItem:"rl2_PopularChannelsModal-module_channelItem_Qgxus",tabDescription:"rl2_PopularChannelsModal-module_tabDescription_V4bjD"};export{l as default};
